import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const StoreInPages = {
  list: 'ListStoreIn',
  add: 'AddStoreIn',
  edit: 'EditStoreIn',
}

const { t } = i18n.global

const title = t('entities.storeIn')
const path = '/store-in'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: StoreInPages.add,
  component: () => import('@/pages/mainPageWithRoute/store-in/AddStoreInPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: StoreInPages.edit,
  component: () => import('@/pages/mainPageWithRoute/store-in/EditStoreInPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: StoreInPages.list,
  component: () => import('@/pages/mainPageWithRoute/store-in/ListStoreInPage.vue'),
  meta: { title, requiresAuth: true },
}

export const StoreIns: RouteRecordRaw = {
  path,
  name: 'StoreIns',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
